import React from 'react';
import LoadingSpinner from './LoadingSpinner';
import './LoadingPage.css';
import { useTranslation } from '../i18n';
import Icon from './Icon';

export interface LoadingPageProps {
  /** Loading mesajı */
  message?: string;
  /** Logo göster */
  showLogo?: boolean;
  /** Arka plan stili */
  background?: 'default' | 'gradient' | 'transparent';
  /** Container sınıfı */
  className?: string;
  /** Close callback (debug için) */
  onClose?: () => void;
}

const LoadingPage: React.FC<LoadingPageProps> = ({
  message,
  showLogo = true,
  background = 'gradient',
  className = '',
  onClose,
}) => {
  const { t } = useTranslation();
  const containerClasses = [
    'loading-page',
    `loading-page--${background}`,
    className
  ].filter(Boolean).join(' ');

  return (
    <div className={containerClasses}>
      {onClose && (
        <button 
          onClick={onClose}
          style={{
            position: 'absolute',
            top: '20px',
            right: '20px',
            background: 'rgba(255,255,255,0.2)',
            border: '1px solid rgba(255,255,255,0.3)',
            color: 'white',
            borderRadius: '50%',
            width: '40px',
            height: '40px',
            cursor: 'pointer',
            fontSize: '18px'
          }}
          aria-label={t('common.close')}
        >
          <Icon name="close" />
        </button>
      )}
      <div className="loading-page-content">
        {showLogo && (
          <div className="loading-logo">
            <span className="logo-icon"><img src='logo.png' width={100} alt='Logo' /></span>
            <h2>Riselio</h2>
          </div>
        )}
        <div style={{ 
          display: 'flex', 
          justifyContent: 'center', 
          alignItems: 'center',
          width: '100%'
        }}>
          <LoadingSpinner
            message={message || t('common.loading')}
            size="large"
            color="primary"
          />
        </div>
      </div>
    </div>
  );
};

export default LoadingPage;
